module.exports = __webpack_public_path__ + "img/touxiang.10a1fbed.png";